import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
//router
import {Link} from 'react-router-dom'
import pic from "../img/WhatsApp Image 2022-10-02 at 3.00.17 PM (2).jpeg"

const pages = [
    
    {
        'path': '/',
        'name': 'Home'
       },
       {
    'path': '/Info',
    'name': 'Info'
     }, 
  {
    'path': '/ml',
    'name': 'Ml Model'
 },{
    'path': '/resources',
    'name': 'Resources'
 }

];

const NavBar = () => {


  return (
    <AppBar position="static" style={{background:"#808385"}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <img src={pic} style={{borderRadius:"100px", height:"100px"}}/>
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              color="inherit"
            >
            </IconButton>
       
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            LOGO
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
                <Link to={page.path} style={{textDecoration: 'none'}}>
                         <Button
                key={page}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page.name}
              </Button>
                </Link>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default NavBar;